import './styles.css';

export function App() {
  return (
    <main className="app-shell">
      <h1>COLOPPO</h1>
    </main>
  );
}
